import React from 'react'
import LinkButton from './LinkButton'
import ActionInfoOutline from 'material-ui-legacy/svg-icons/action/info-outline'

const InfoLinkButton = ({ url, style, label, icon }) => (
  <LinkButton
    url={url}
    style={style}
    label={label || 'Details'}
    icon={<ActionInfoOutline />}
  />
)

export default InfoLinkButton



// WEBPACK FOOTER //
// ./src/components/UI/InfoLinkButton.jsx